import { Select } from '.';
import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-select', observe: true })
export class SelectComponent {
	constructor(private element: HTMLSelectElement) {
		new Select(this.element, {
			searchClearIconHtml: `<span class="c-icon">
				<svg viewBox="0 0 24 24"><use xlink:href="/icons.svg#close"></use></svg>
			</span>`
		});
	}
}
